import { StrictMode } from "react"

import { QueryClientProvider } from "@tanstack/react-query"
import { IDirective } from "angular"
import { createRoot } from "react-dom/client"

import { queryClient } from "@/query/queryClient"

import { StudentAssignmentsList } from "./StudentAssignmentsList"
import StudentAssignmentsListController from "./StudentAssignmentsList.controller"

export function StudentAssignmentsListDirective(): IDirective {
  return {
    restrict: "E",
    controller: "StudentAssignmentsListV2Controller",
    link: function (scope, element, _attributes, controller) {
      const root = createRoot(element[0])

      root.render(
        <StrictMode>
          <QueryClientProvider client={queryClient}>
            <StudentAssignmentsList
              controller={controller as StudentAssignmentsListController}
            />
          </QueryClientProvider>
        </StrictMode>,
      )

      scope.$on("$destroy", () => {
        root.unmount()
      })
    },
  }
}
